const en = {
  app: {
    title: "BeeApp",
    tagline: "Brow specialist assistant",
  },
  linked: {
    eyebrow: "Sign-in methods",
    hint: "Link Telegram and Google/Apple into one account: the same purchases and history wherever you sign in. If the other method already has its own BeeApp account, its purchases and history move here.",
    linked: "Linked",
    notLinked: "Not linked",
    link: "Link",
    waitTelegram: "Confirm in the BeeApp bot («Merge»). The code in the bot's message should match:",
    waitGoogle: "In the browser that opened, sign in with Google or Apple and confirm. The code on the page should match:",
    done: "Done — the accounts are merged.",
    errConflict: "Could not link: one of the accounts already has another Telegram or Google linked. Please write to us via «Report a problem».",
    errGeneric: "Could not link. Please try again.",
  },
  adminUsers: {
    grantTitle: "Grant access",
    daysInput: "Days",
    grantBtn_one: "Grant for {{count}} day",
    grantBtn_other: "Grant for {{count}} days",
    granted: "Access granted. The user got a Telegram message (if they use Telegram).",
    cancelTitle: "Cancel access",
    cancelAll: "All access",
    confirmRevoke: "Cancel «{{block}}» for {{name}} now? This does not refund money — refunds are made in PayPal or bePaid.",
    confirmRevokeAll: "Cancel all access for {{name}} now? This does not refund money — refunds are made in PayPal or bePaid.",
    revokeYes: "Yes, cancel",
    revoked: "Access cancelled.",
    deleteBtn: "Delete user",
    confirmDelete: "Delete {{name}} for good? Access, calculation history, chat and progress go. Payment records stay. This cannot be undone.",
    deleteYes: "Yes, delete",
    deleted: "User deleted.",
    errDeleteAdmin: "An admin cannot be deleted — remove the admin rights first (/deladmin in the bot).",
    errDeleteSelf: "You cannot delete yourself.",
    tab_users: "Users",
    tab_calcs: "Calculations",
    calcSearch: "Calculation №, client or master",
    calcNotFound: "Calculation №{{number}} not found.",
    master: "master {{name}}",
    title: "Users",
    menuDesc: "Who uses the app: access, payments, progress",
    chipSearch: "Search",
    chipProgress: "Progress",
    sumUsers: "total",
    sumAccess: "with access",
    sumActive: "active in 7 days",
    sumNew: "new in 7 days",
    search: "Name, @username, e-mail or Telegram ID",
    filter: "Filter",
    f_all: "All",
    f_access: "With access",
    f_free: "Never bought",
    f_expired: "Access ended",
    f_new: "New",
    f_admins: "Admins",
    sortBy: "Sort:",
    s_activity: "by activity",
    s_created: "by sign-up",
    s_name: "by name",
    found_one: "{{count}} found",
    found_other: "{{count}} found",
    empty: "Nobody found.",
    more: "Show more",
    admin: "Admin",
    hasAccess: "Access",
    expired: "Ended",
    free: "Free",
    daysLeft_one: "{{count}} day",
    daysLeft_other: "{{count}} days",
    until: "until {{date}}",
    paid: "Paid",
    selections: "Calculations",
    lessons: "Lessons done",
    messages: "Messages to Anya",
    worksShort_one: "{{count}} work",
    worksShort_other: "{{count}} works",
    signIn: "Sign-ins: TG — Telegram, G — Google/Apple",
    minAgo: "{{count}} min ago",
    hAgo: "{{count}} h ago",
    dAgo: "{{count}} d ago",
    joined: "In the app since {{date}}",
    lastMessage: "last message {{when}}",
    chapters: "Progress by chapter",
    chapterLine: "done {{done}} · started {{started}} of {{total}}",
    intro: "Introduction",
    accessHistory: "Access history",
    payments: "Payments",
    recentSelections: "Recent calculations",
    noClientName: "no client name",
    src_paypal: "PayPal",
    src_bepaid: "card",
    src_bepaid_link: "card by link",
    src_invite: "invite",
    src_admin_grant: "granted by admin",
  },
  auth: {
    linkTitle: "Merge the accounts?",
    linkText: "The Google account «{{google}}» becomes one account with the Telegram account «{{telegram}}»: purchases and history are combined, and you can sign in either way.",
    linkYes: "Yes, merge",
    linkDone: "Done — the accounts are merged. Go back to Telegram.",
    telegramLogin: "Sign in with Telegram",
    googleFromTelegram: "Sign in with Google or Apple",
    googleFromTelegramHint: "Your browser will open: sign in there and confirm — the app in Telegram will sign in to that account.",
    telegramAccountHint: "Your Telegram account — with what you bought in the app.",
    waitTelegramTitle: "Confirm in Telegram",
    waitTelegramText: "Open the BeeApp bot and tap «Sign in». The code in the bot's message should match:",
    waitGoogleTitle: "Confirm in the browser",
    waitGoogleText: "Sign in with Google or Apple in the browser and confirm. The page should show the same code:",
    openTelegram: "Open Telegram",
    openBrowserAgain: "Open the browser again",
    waiting: "Waiting for confirmation…",
    cancel: "Cancel",
    loginExpired: "The sign-in timed out or was cancelled. Please try again.",
    approveEyebrow: "Sign-in to Telegram",
    approveTitle: "Sign in to BeeApp in Telegram with this account?",
    approveAs: "Account:",
    approveDevice: "Requested from: {{device}}",
    approveCheck: "Telegram should show the code",
    approveWarn: "Confirm only if you just tapped «Sign in with Google» in BeeApp in Telegram yourself and the code matches. If someone else sent you this link, tap «Not me».",
    approveYes: "Yes, sign in to Telegram",
    approveNo: "Not me",
    approveDone: "Done! Go back to Telegram — the app is signed in to this account.",
    approveDeclined: "Sign-in cancelled.",
    approveNeedGoogle: "Only a Google or Apple account can confirm. Sign out and sign in with Google or Apple.",
    approveLogout: "Sign out and use Google",
    login: "Sign in",
    register: "Sign up",
    createAccount: "Create account",
    welcomeBack: "Welcome back!",
    orContinueWithEmail: "Or continue with email",
    alreadyHaveAccount: "Already have an account? Sign in",
    dontHaveAccount: "No account? Sign up",
    playAsGuest: "Continue as guest",
    emailPlaceholder: "Email address",
    passwordPlaceholder: "Password",
    confirmPasswordPlaceholder: "Confirm password",
    passwordsDoNotMatch: "Passwords do not match",
    googleLogin: "Google",
    appleLogin: "Apple",
    guestLoginFailed: "Guest sign-in failed",
    errGeneric: "Sign-in failed. Please try again.",
    errPopupBlocked: "Your browser blocked the sign-in window. Allow pop-ups and try again.",
    errUnauthorizedDomain: "Sign-in isn't allowed from this domain. Please contact support.",
    errNetwork: "Can't reach the server. Check your connection and try again.",
    errProviderDisabled: "This sign-in method is temporarily unavailable.",
    forgotPassword: "Forgot password?",
    resetInstructions: "Enter your email — we'll send a reset link.",
    enterEmailForReset: "Enter email to reset password",
    sendResetEmail: "Send reset link",
    resetEmailSent: "Email sent! Check your inbox.",
    backToLogin: "Back",
    terms: "By continuing you agree to the Terms of Use and Privacy Policy.",
  },
  maintenance: {
    title: "Under maintenance",
    body: "The app is under maintenance. We'll be back shortly!",
  },
  adminSettings: {
    title: "App settings",
    menuDesc: "Sections, subscription prices, limits and maintenance mode",
    sectionsChip: "Sections",
    pricesChip: "Prices",
    save: "Save settings",
    saved: "Settings saved",
    sections: "App sections",
    sectionsHint: "A disabled section stays in the menu marked \u00abSoon\u00bb and cannot be opened. As an admin you always keep full access.",
    section_selection: "Selection",
    section_study: "Study & exercises",
    section_history: "Past calculations",
    section_games: "Practice",
    section_chat: "Chat with Anya",
    plans: "Plans & prices",
    plansHint: "A price of 0 shows as \u00abSoon\u00bb — the plan is visible without a figure. Payment still goes through you: the client messages you on Telegram and you grant the days.",
    currency: "Currency",
    addPlan: "Add plan",
    newPlan: "New plan",
    planTitleRu: "Title (RU)",
    planTitleEn: "Title (EN)",
    planPrice: "Price",
    planPriceUsd: "Price (EN storefront)",
    currencyEn: "Currency in the English UI",
    bynRate: "bePaid rate: BYN per 100 ₽",
    bynRateHint: "bePaid charges Belarusian roubles: the ₽ price × rate / 100, rounded to a whole rouble. National Bank of Belarus rate on 28.10.2026: 3.66.",
    planDays: "Days of access",
    planBadgeRu: "Badge (RU)",
    planBadgeEn: "Badge (EN)",
    planGrants: "Unlocks when paid online, days (empty — not included)",
    planGrantsHint: "Paying on the website via PayPal charges the $ price and grants these blocks for these days.",
    planGrantsEmpty: "Nothing selected — this plan can't be bought online; the card points to the admin.",
    browserCheckout: "Pay in browser from Telegram",
    browserCheckoutHint: "In the Telegram app, plans get a “Pay in browser” button that opens the website already signed in. Telegram's rules require Stars for digital goods in Mini Apps — switch this off if Telegram asks.",
    planTier: "Tariff (durations of one tariff share a card; a higher one is an upgrade with credit)",
    planTierNone: "— its own card",
    planTierFeedback: "feedback",
    upgradeCredit: "Credit when moving to a higher plan",
    upgradeCreditHint: "Moving to a ticked plan takes the unused paid days of the current plan off the price, and the new plan starts today. An unticked one is full price; the paid days are kept and the new period is added on top.",
    upgradeCredit_challenge: "From MIXES to CHALLENGE + MIXES",
    upgradeCredit_feedback: "To CHALLENGE + MIXES + feedback",
    pricingNotice: "Launch-price notice",
    pricingNoticeOn: "Show above the plans",
    pricingNoticeHint: "A “Launch prices” notice on the plans page and a mark in checkout. Switch it off once prices go up.",
    planPayLink: "bePaid payment link (you confirm payments in “Online payments”; empty — no button)",
    planActive: "Show in the app",
    planZeroPrice: "No price set — will show as \u00abSoon\u00bb",
    planDelete: "Delete plan",
    limits: "Free limits",
    courses: "Courses",
    coursesHint: "A closed course is locked for everyone but admins: its lessons do not open and the API withholds their content. You still see it in full, so it can be checked before launch.",
    course_base_hint: "Paper, strokes and schemes — covered by the main subscription.",
    course_ombre_hint: "Using the Selection tool and Theory. Sold separately; switch on once the lessons are recorded.",
    freeSelections: "Free selections",
    freeSelectionsHint: "How many calculations work without a subscription. 0 = subscribers only.",
    freeLessons: "Free lessons per chapter",
    freeLessonsHint: "How many lessons at the start of EVERY chapter open without a subscription. Work can't be submitted from them. 0 = everything is paid.",
    announcement: "Announcement",
    announcementOn: "Show announcement",
    announcementHint: "A short line at the top of the main menu.",
    announcementRu: "Announcement text (RU)",
    announcementEn: "Announcement text (EN)",
    service: "Contact & maintenance",
    contact: "Telegram contact",
    contactHint: "Username with or without @ — shown to clients next to the plans.",
    maintenance: "Maintenance mode",
    maintenanceHint: "Everyone but admins sees a holding screen.",
    maintenanceWarning: "Heads up: once saved, the app is closed to everyone except admins.",
    maintenanceRu: "Message (RU)",
    maintenanceEn: "Message (EN)",
  },
  menu: {
    greeting: "Welcome",
    continueTitle: "Continue watching",
    lessonN: "Lesson {{n}}",
    startSelection: "Start selection",
    startSelectionDesc: "Step-by-step pigment, cartridge and layup selection",
    study: "Study & exercises",
    studyDesc: "Video lessons & tasks with feedback from Anya",
    lessonsChip: "Lessons",
    history: "Past calculations",
    historyDesc: "Saved client calculations · search by name and date",
    games: "Practice",
    gamesDesc: "Course quiz and a stroke trainer to practise your movements",
    findUs: "Find us",
    findUsDesc: "Bee Company socials & website",
    logout: "Sign out",
    lockedLessons: "Some lessons are locked",
    learnSubscription: "Tap to learn about subscription",
    sectionSoon: "Soon",
  },
  selection: {
    calcNumber: "Calculation №{{number}}",
    calcNumberHint: "If something looks wrong, quote this number and we will find exactly this calculation.",
    title: "Selection",
    step: "Step",
    of: "of",
    back: "Back",
    next: "Next",
    finish: "Get result",
    toMainMenu: "Back to main menu",
    restart: "Start over",
    summary: "Summary",
    required: "Make a selection for each item to continue.",
    mixRequired: "First choose one working mix from the three options.",
    schemeRequired: "Choose a layup scheme to continue to cartridge selection.",
    cartridgeRequired: "Choose the skin type — it is required to select a cartridge and generate the report.",
    quotaLeft: "Free selections left",
    limitReached: "You've used all 5 free selections. Get premium for unlimited access — contact the admin.",
    review: "Review your inputs and run the engine.",
    notSet: "—",
    s1Title: "Choose pigment",
    pigmentMineral: "Mineral pigment",
    pigmentHybrid: "Hybrid pigment",
    s2Title: "Build the mix",
    skinDepth: "Skin tone",
    depthFair: "Very fair",
    depthLight: "Light",
    depthOlive: "Tanned",
    depthTan: "Tan",
    depthDark: "Dark",
    skinTone: "Skin undertone",
    skinToneCold: "Cold",
    skinToneWarm: "Warm",
    skinToneNeutral: "Neutral",
    oldPermanent: "Old PMU (residue color)",
    pmu_none: "No old PMU",
    pmu_gray: "Gray",
    pmu_green: "Green (with white)",
    pmu_yellow: "Yellow",
    pmu_orange: "Orange",
    pmu_salmon: "Salmon",
    pmu_red: "Red",
    pmu_violet: "Violet",
    yes: "Yes",
    no: "No",
    eyeColor: "Eye color",
    zoomHint: "Long-press a photo to zoom",
    eye_brown: "Brown",
    eye_copper_brown: "Copper brown",
    eye_green: "Green",
    eye_blue: "Blue",
    eye_gray: "Gray",
    irisMarker: "Iris flecks",
    irisMarkerHint: "Mark the colour visible inside a brown or copper iris separately",
    irisMarker_none: "No green flecks",
    irisMarker_green: "Green",
    irisMarker_yellow_green: "Yellow-green",
    hairColor: "Hair color",
    couperose: "Couperose (visible capillaries)",
    couperoseHint: "Couperose example — long-press the photo to zoom",
    hairRed: "Red",
    hairBlonde: "Blonde",
    hairBrown: "Brown",
    hairChestnut: "Chestnut",
    hairBlack: "Black",
    desiredDepth: "How dark should the brows be?",
    desiredDepthHint: "For this profile, depth is added with a separate mineral finishing pass",
    desiredDepth_natural: "Natural depth",
    desiredDepth_dark: "Make darker",
    s3Title: "Choose cartridge",
    skinDensity: "Skin type",
    densityDensePorous: "Dense / porous",
    densityThinDry: "Thin / dry",
    densityDense: "Dense",
    densityPorous: "Porous",
    densityThin: "Thin",
    densityDry: "Dry",
    s4Title: "Layup scheme",
    hairPresence: "Hair condition",
    hairHas: "Has hair — good hair growth",
    hairNone: "No hair",
    hairPartial: "Partially missing in the brow body",
    hairOverplucked: "Over-plucked",
    hairDense: "Dense",
    hairStiff: "Stiff",
    hairType: "Hair structure",
    hairTypeStiff: "Stiff",
    hairTypeSoft: "Soft",
    hairGrowth: "Hair growth direction",
    hairGrowthNormal: "Normal",
    hairGrowthDown: "Grows downward in the body and tail",
    desiredEffect: "Desired result",
    desiredEffectHint: "The client's wish decides the layup scheme",
    effectAiry: "Light and airy",
    effectDefined: "Defined, with a drawn bottom",
    pickMix: "Build the mix",
    mixReady: "Choose your working mix",
    mixNeutral: "Base — neutral",
    mixWarm: "Warmer",
    mixLight: "Lighter",
    mixNeutralWhy: "A balanced everyday option for a natural result.",
    mixWarmWhy: "A warmer shade: 2 more drops of the warm pigment (№11 Espresso, on the mineral line №9), no diluent.",
    mixLightWhy: "Lighter and softer: one more drop of diluent.",
    hybridBrightPressure: "Artist note: use very light machine pressure with a hybrid mix. The denser the layup becomes, the less pressure to use on each pass.",
    coverupFirstHint: "Cover the old PMU first, so this mix is shown before the colour options.",
    chooseThisMix: "Use this mix",
    mixSelected: "Selected",
    continueToScheme: "Continue",
    schemeHelpTitle: "Need help choosing a layup scheme?",
    schemeHelpText: "Choose how you want to work from the course schemes, or skip this stage and continue to the cartridge.",
    schemeGroupClosed: "Tap to see the options",
    schemeGroupOpen: "Pick one of the options below",
    schemeGroupChosen: "Option chosen — tap to change",
    chooseScheme: "Choose a scheme",
    skipScheme: "Skip",
    manualSchemeHint: "Choose by the client's request and how you want to work. Hair-growth guidance is included below.",
    schemeGroupDefined: "Defined bottom — light top",
    schemeGroupGraphics: "Graphics",
    schemeFastFluffy: "Fast and fluffy",
    schemeFastFluffyDesc: "A fast client technique with a dense bottom and fluffy top. Best when good or dense hair growth can support the lower edge.",
    schemeClassic: "Classic layup",
    schemeClassicDesc: "A classic gradient with an accent at the arch. Suits normal growth direction and enough natural brow hair.",
    schemeDecorativeBottom: "Decorative defined bottom",
    schemeDecorativeBottomDesc: "A pronounced lower third and light top. For a decorative request; choose a defined bottom when brow hair is present.",
    schemeDecorativeGraphics: "Decorative graphics",
    schemeDecorativeGraphicsDesc: "Sector graphics with a dense tail and airy head. Follow the natural hair-growth direction when drawing the shape.",
    schemeSoftGraphics: "Soft graphics",
    schemeSoftGraphicsDesc: "Controlled soft graphics with 50/50 layering; set the contour last. For a more delicate shape.",
    schemeBorderless: "No defined borders",
    schemeBorderlessDesc: "A soft brow with a centre accent and no outlines. The lesson for it is linked in the result.",
    schemeLadyPlus: "Lady +",
    schemeLadyPlusDesc: "A delicate narrow 50+ shape with a centre accent that continues natural hair growth.",
    schemeAsian: "Asian",
    schemeAsianDesc: "For hair growing downward in the body and tail: a weightless head, an accented centre and pronounced arch.",
    schemeLessonMissing: "The lesson for this scheme could not be found.",
    chosenScheme: "Selected scheme",
    schemeSkipped: "Skipped",
    schemeChoice_fast_fluffy: "Fast and fluffy",
    schemeChoice_classic: "Classic layup",
    schemeChoice_decorative_bottom: "Decorative defined bottom",
    schemeChoice_decorative_graphics: "Decorative graphics",
    schemeChoice_soft_graphics: "Soft graphics",
    schemeChoice_borderless: "No defined borders",
    schemeChoice_lady_plus: "Lady +",
    schemeChoice_asian: "Asian",
    pickCartridge: "Choose cartridge",
    fullReport: "Get full report",
    resultTitle: "Selection result",
    predictedColors: "Predicted color",
    yourMix: "Your mix",
    badgeMain: "Main",
    badgeAlt: "Alternative",
    badgeCoverup: "Cover-up",
    ratio: "Ratio",
    totalDrops: "Total:",
    dropsShort: "drops",
    copyMix: "Copy the mix",
    copyShort: "Copy",
    resultUntitled: "Procedure recipe",
    tileMix: "Mix",
    tileScheme: "Scheme",
    tileSchemeSkipped: "Not chosen",
    stepCoverup: "First · cover-up",
    stepWorkingMix: "Then · working mix",
    cartridge: "Cartridge",
    ruleApplied: "Expert rule applied",
    finishPass: "Finishing pass",
    purePigment: "pure pigment",
    layupScheme: "Layup scheme — strokes",
    layupStyle: "Style",
    schemeLessonLabel: "Lesson for this scheme",
    schemeLessonLocked: "Lesson requires a subscription — see plans",
    layupComing: "A visual layup scheme (Anya's animation) is coming here soon.",
    whyTitle: "Why this selection",
    pass: "Pass",
    careTitle: "Client aftercare recommendations",
    watchVideo: "Watch video",
    clientName: "Client name",
    clientNamePlaceholder: "e.g. Anna P.",
    clientNameHint: "Optional. Helps you find this calculation later.",
    shareClient: "Send to client",
    shareHeader: "Brow aftercare instructions",
    copied: "Copied!",
  },
  history: {
    title: "Past calculations",
    searchName: "Client name or calculation №",
    searchChip: "Search",
    dateChip: "By date",
    dateFrom: "From",
    dateTo: "To",
    clear: "Clear",
    unnamed: "Unnamed",
    emptyTitle: "Nothing yet",
    emptyHint: "Saved calculations will appear here after your first run.",
    emptyFiltered: "No calculations match the current filters.",
  },
  games: {
    title: "Practice",
    intro: "Reinforce the course material and rehearse your device movements, game-style.",
    backToGames: "Back to practice",
    quiz: {
      title: "Quiz",
      desc: "Test your knowledge: pigments, cartridges, technique and aftercare.",
      chip: "Quiz",
      question: "Question",
      next: "Next",
      finish: "Finish",
      again: "Play again",
      great: "Great score!",
      keepGoing: "Keep practising!",
    },
    stroke: {
      title: "Stroke trainer",
      desc: "Trace the device movement paths: pendulum, fan, diagonals.",
      chip: "Movements",
      draw: "Trace the dotted line with your finger",
      retry: "Retry",
      tip: "Keep the line smooth and right on the dotted guide, without lifting your finger.",
    },
  },
  study: {
    title: "Study & exercises",
    free: "Free",
    locked: "Locked",
    available: "Available",
    open: "Open",
    demo: "Demo lesson",
    templates: "Print templates",
    templatesHint: "Print them and stretch latex on top — this is what you practise the movements on.",
    template_blocks: "Blocks & gradients",
    template_blocks_for: "For the \u00abStrokes\u00bb chapter",
    template_brows: "Brow outlines",
    template_brows_for: "For the \u00abSchemes\u00bb chapter",
    templateOpen: "Open",
    templateCopy: "Link",
    templateCopied: "Copied",
    unlock: "Unlock with a subscription",
    feedbackTitle: "Feedback from Anya",
    feedbackPlaceholder: "Describe your work or ask a question…",
    submit: "Submit",
    submitted: "Submitted",
    anyaReply: "Anya's reply",
    status_not_started: "Not started",
    status_in_progress: "In progress",
    status_submitted: "Under review",
    status_reviewed: "Reviewed",
    status_done: "Done",
    lessons: "lessons",
    exercises: "exercises",
    progress: "Your progress",
    comingSoon: "Coming soon",
    sectionPaper: "Paper",
    sectionStrokes: "Strokes",
    sectionSchemes: "Schemes",
    sectionSelection: "Using the Selection tool",
    sectionTheory: "Theory",
    course_base: "CHALLENGE — course",
    course_ombre: "Ombre Brows",
    courseClosedHint: "A separate course, bought on top. The lessons are still being recorded — opening very soon.",
  },
  achv: {
    gotIt: "Got it!",
    lessonDoneTitle: "Lesson complete!",
    passedTitle: "Lesson passed!",
    passedMsg: "Anya approved your work",
    retryTitle: "Almost there!",
    retryMsg: "Anya left feedback — give it another go",
  },
  review: {
    title: "Task Review",
    menuDesc: "Students' work to review: approve or send back with feedback",
    pending: "Pending",
    approve: "Approve",
    decline: "Send back",
    feedbackChip: "Feedback",
    feedbackPlaceholder: "Feedback to the student: what's good, what to fix…",
    emptyTitle: "All reviewed!",
    emptyHint: "New submissions will appear here automatically.",
  },
  exercise: {
    heading: "Exercise",
    whatToSubmit: "What to submit",
    selectPhoto: "Select Photo",
    submitWork: "Submit Work",
    resubmit: "Resubmit",
    underReview: "Work submitted for review. Anya will review it and give feedback.",
    sendWork: "Send work for review",
    workSent: "Work sent! Watch for Anya's reply in the chat.",
    discussInChat: "Questions and discussion happen in the chat with Anya.",
    subscriptionToSubmit: "Reviews come with a subscription",
    subscriptionToSubmitHint: "This is a demo lesson: watch and read it freely — sending work to Anya needs a subscription.",
    openPlans: "See the plans",
    example: "Example of finished work",
    passed: "🎉 Exercise passed! Great work.",
    deadlinePassed: "Deadline passed",
    daysLeft: "{{count}} days left",
    deadlineAfterSubmit: "Deadline: {{days}} days after submission",
    chat: "Chat with Anya",
    chatEmpty: "Ask a question — Anya will reply",
    chatPlaceholder: "Message Anya…",
    chatPlaceholderUnified: "Question or a photo of your work…",
    chatEmptyUnified: "Ask Anya a question or send a photo of your work for review — all in one chat.",
    statusSubmitted: "Under review",
    statusPassed: "Passed",
    statusFailed: "Needs revision",
  },
  quizStats: {
    title: "Quiz statistics",
    menuDesc: "All questions and how people answer",
    overall: "Quiz overall",
    correct: "correct",
    answers: "answers",
    noAnswers: "no answers",
    totalAnswers: "Total answers",
  },
  access: {
    title: "Block access",
    none: "no access",
    notOwned: "no access",
    daysLeft: "{{count}} days left",
    days: "Days to add",
    hint: "Ticked blocks are extended by that many days; unticked ones are revoked. Days are added to what is left rather than restarting the count.",
    apply: "Apply",
    saved: "Access updated",
    legacyGrant: "This user has an old all-inclusive premium grant from before blocks existed. Removing one block keeps the others for the same period.",
  },
  lessonActions: {
    sendWork: "Send work",
    askQuestion: "Ask a question",
    noFeedbackTitle: "Reviews and chat come with the feedback plan",
    noFeedbackHint: "Your plan opens every lesson, but Anya does not review your work and cannot reply in the chat. Reviews and chat are added separately.",
    seePlans: "See the plans",
  },
  chat: {
    attach: "Attach photo",
    tooLarge: "File too large. Try a smaller photo.",
    askAboutLesson: "Ask a question about this lesson",
    askingAbout: "Question about lesson",
    returnToLesson: "Back to lesson",
    title: "Chat with Anya",
    menuDesc: "Questions and work for review — all in one chat",
    placeholder: "Message or photo…",
    empty: "Message Anya or send a photo of your work — she'll reply here.",
    lockedTitle: "Chat with Anya — in the plan with feedback",
    lockedHint: "Messaging Anya and work reviews come with the “CHALLENGE + MIXES + feedback” plan — with it you can write to Anya and send your work for review.",
    lockedEmpty: "Your conversation with Anya will appear here.",
    adminTitle: "Chats",
    adminMenuDesc: "Conversations with participants — questions & work",
    noChats: "No conversations yet",
    participants: "Participants",
    pending: "to review",
    userId: "ID",
    noIdentifiers: "no Telegram or e-mail",
  },
  account: {
    pendingCount: "{{count}} awaiting attention",
    title: "Profile",
    subscription: "Subscription",
    noSubscription: "No subscription",
    active: "Active",
    expired: "Expired",
    cancelled: "Cancelled",
    activeUntil: "Active until",
    expiredOn: "Expired",
    daysLeft: "days left",
    remaining: "remaining",
    grantedByAdmin: "Granted by admin",
    unlockAll: "Unlock all lessons",
    unlockAllDesc: "MIXES — mixes and needle selection, CHALLENGE — the course, individual feedback: pick a plan below",
    plans: "Subscription plans",
    plan1m: "1 month",
    plan3m: "3 months",
    plan6m: "6 months",
    bestValue: "Best value",
    comingSoon: "Coming soon",
    paymentSoon: "Payment coming soon — stay tuned!",
    memberSince: "Member since",
    renewContact: "Contact admin to renew",
    expiresWarning: "Subscription expires in",
    daysAbbr: "d",
    contactToBuy: "To subscribe, message",
  },
  inbox: {
    title: "Inbox",
    menuDesc: "Student questions and work to review",
    questions: "Questions",
    works: "Works",
    chatEmpty: "No messages yet",
    noQuestions: "No new questions 🎉",
    noWorks: "Nothing to review 🎉",
    replyPlaceholder: "Your reply to the student…",
    sendReply: "Reply",
    noteOrReply: "Note / message to the student…",
    sendMessageOnly: "Send message",
    pass: "Pass",
    passed: "Passed",
    needsWork: "Needs work",
    fail: "Needs work",
  },
  admin: {
    whatToGrant: "What to grant (everything by default)",
    pickBlock: "Pick at least one block",
    pendingSaved: "{{name}} hasn\u2019t opened the app yet \u2014 the grant is saved: {{blocks}}. It activates on their first login and the day count starts then. Expires {{until}}.",
    title: "Admin",
    grantTitle: "Grant premium",
    grantDesc: "Premium unlocks all lessons and unlimited selection. Enter the client's @username, email (for Google sign-in), or Telegram ID and a duration in days.",
    targetPlaceholder: "@username, email or Telegram ID",
    daysPlaceholder: "Days",
    grantBtn: "Grant premium",
    granted: "Premium granted",
    notFound: "User not found",
    invalid: "Enter a user and a duration in days",
  },
  common: {
    loading: "Loading…",
    error: "Something went wrong",
    soon: "Soon",
    theme: "Theme",
  },
  invite: {
    adminTitle: "Invite links",
    menuDesc: "Single-use links that grant access — to new and existing users",
    chipLink: "Link",
    createTitle: "New link",
    createHint: "Choose what the link unlocks and for how many days. It works once — for the first person who opens it, in Telegram or a browser. Someone without an account gets the access right after signing up.",
    blocks: "Unlocks",
    accessDays: "Access, days",
    validDays: "Link valid for, days",
    days_one: "{{count}} day",
    days_other: "{{count}} days",
    note: "Label (only you see it)",
    notePlaceholder: "E.g. Maria, paid 14.10",
    rulesHint: "Access days start when the link is activated. An unused link expires in {{count}} days.",
    create: "Create link",
    created: "Link ready — send it",
    linkTelegram: "For Telegram — activates right in the bot",
    linkWeb: "For a browser — after Google or Apple sign-in",
    copy: "Copy",
    copied: "Copied",
    copyFailed: "Failed",
    shareTelegram: "Send via Telegram",
    shareText: "Your BeeApp invitation — open the link to activate your access:",
    noBot: "The Telegram link is unavailable right now: the bot did not respond. The browser link works.",
    listTitle: "Your links",
    filterActive: "Active",
    filterAll: "All",
    empty: "No links yet.",
    emptyActive: "No active links.",
    redeemedCount_one: "{{count}} link used — see All.",
    redeemedCount_other: "{{count}} links used — see All.",
    revoke: "Cancel link",
    revokeConfirm: "Cancel this link? Nobody will be able to use it.",
    redeemedBy: "{{who}}, {{date}} ({{via}})",
    viaWeb: "browser",
    validUntil: "valid until {{date}}",
    createdOn: "created {{date}}",
    status: {
      active: "Active",
      redeemed: "Used",
      expired: "Expired",
      revoked: "Cancelled",
    },
    loginTitle: "You've been given access",
    loginHint: "Sign in to activate it on your account.",
    okTitle: "Invitation activated",
    alreadyTitle: "This invitation is already yours",
    okMessage_one: "Unlocked: {{blocks}} — for {{count}} day.",
    okMessage_other: "Unlocked: {{blocks}} — for {{count}} days.",
    failTitle: "The invitation didn't work",
    err: {
      INVITE_NOT_FOUND: "Invitation not found. Check that the whole link was copied.",
      INVITE_USED: "This link has already been used. Ask the admin for a new one.",
      INVITE_EXPIRED: "This link has expired. Ask the admin for a new one.",
      INVITE_REVOKED: "This link was cancelled by the admin.",
      INVITE_ADMIN: "You are an admin and already have full access. The link stays unused.",
      generic: "Could not activate the invitation.",
    },
  },
  pay: {
    eyebrow: "Payment",
    choosePlan: "Choose a plan below — pay with PayPal or a card",
    renewOnline: "Renew below with PayPal or a card.",
    tapToBuy: "Tap a plan to pay",
    oneTime: "one-time payment",
    unlocks: "What you get",
    forDays_one: "{{count}} day",
    forDays_other: "{{count}} days",
    sandbox: "PayPal test mode: no real money is charged.",
    processing: "Confirming your payment…",
    rubNote: "Pay with your PayPal account or a card.",
    cardNote: "Pay with your PayPal account or a card.",
    doneTitle: "Payment complete",
    doneText: "“{{plan}}” is now unlocked on your account.",
    doneButton: "Done",
    pendingTitle: "Payment processing",
    pendingText: "PayPal is still checking the payment. Access opens automatically once it is confirmed — usually within minutes.",
    methodWallet: "— your wallet, if you have one",
    methodCard: "Bank card",
    methodCardNote: "— Visa, Mastercard and more, no PayPal account needed",
    doneTextTelegram: "“{{plan}}” is unlocked on your account — in Telegram too.",
    backToTelegram: "Back to Telegram",
    listPrice: "Plan price",
    creditUnused: "Credit for unused days",
    upgradeNote: "The new plan starts today for its full period; the unused days of your current plan are already taken off the price.",
    stepUpNote: "Full-price switch. The paid days of your current plan are not lost — the new period is added on top.",
    yourPrice: "Your renewal price",
    priceKeptNote: "You renew at the price you bought at — it is kept while your plan is active. Once it has ended, renewal is at the current price.",
    err: {
      PAYMENTS_WEB_ONLY: "Payment is available on the website only, not in Telegram.",
      PAYMENTS_DISABLED: "Online payment is switched off right now. Please contact the admin.",
      PLAN_NOT_PURCHASABLE: "This plan can't be bought online. Please contact the admin.",
      PAYPAL_UNAVAILABLE: "PayPal isn't responding. Try again in a minute.",
      PAYMENT_DECLINED: "The payment was declined. Choose another method in the PayPal window.",
      PAYMENT_NOT_APPROVED: "The payment wasn't approved in PayPal. Please try again.",
      PAYMENT_NOT_COMPLETED: "PayPal didn't confirm the payment — you were not charged. Please try again.",
      PAYMENT_CANCELLED: "This order was replaced by a newer one — no money was taken. Please open the payment again.",
      PAYMENT_NOT_FOUND: "Order not found. Open the payment again.",
      SDK: "PayPal couldn't load. Check your connection or turn off your ad blocker.",
      generic: "The payment didn't go through. Please try again.",
    },
  },
  planCard: {
    access: "Access for {{term}}",
    oneTime: "one-time payment",
    payPaypal: "Pay ${{price}} · PayPal",
    writeAdmin: "Message the admin",
    choose: "Choose",
    cardNoAccount: "Pay by card — no PayPal account needed",
    payInBrowser: "Pay in browser · ${{price}}",
    browserHint: "Opens the website, already signed in. PayPal or a bank card — no account needed.",
    durYear: "Year",
    durMonths_one: "{{count}} month",
    durMonths_other: "{{count}} months",
    duration: "Period",
    forTerm: "for {{term}}",
    perMonth: "a month",
    yourPlan: "Your plan",
    until: "until {{date}}",
    mostComplete: "All included",
    includedInYours: "Already in your plan",
    upgradeFor: "Upgrade for ${{price}}",
    renewFor: "Renew · ${{price}}",
    creditLine: "${{credit}} credited for the days left on your current plan",
    stepUpKeep: "No credit: the paid days of your current plan stay, the new period is added on top",
    launchTitle: "Launch prices",
    launchPill: "launch price",
    priceKept: "Your price is kept: ${{price}} instead of ${{list}}, while your plan is active",
    payByLink: "Card · {{price}} ₽",
    pay: "Pay",
    renew: "Renew",
    switchTo: "Switch to this plan",
    methodsHint: "Visa and Mastercard work with either method; MIR and Belkart — «Card»",
  },
  payments: {
    title: "Online payments",
    hint: "Recent PayPal payments on the website. Refunds are made in PayPal; access is not removed automatically after a refund — decide in Block access.",
    empty: "No payments yet.",
    liveTotal: "Real payments: {{count}} · ${{total}}",
    showUnpaid: "Show unpaid",
    hideUnpaid: "Hide unpaid",
    waiting_one: "{{count}} link payment awaits confirmation",
    waiting_other: "{{count}} link payments await confirmation",
    confirm: "Confirm",
    reject: "Reject",
    rejectConfirm: "Reject this payment? No access will be granted.",
    status_cancelled: "Replaced by a newer order",
    status_credit_conflict: "Paid, no access — credit already used",
    status_paid_cancelled: "Cancelled order was paid — decide by hand",
    status_claimed: "Awaiting check",
    status_completed: "Paid",
    status_created: "Not paid",
    status_failed: "Failed",
    status_refunded: "Refunded",
    status_reversed: "Reversed",
  },
  handoff: {
    confirmEyebrow: "Sign-in from Telegram",
    confirmTitle: "Continue with this account?",
    confirmText: "You will be signed in as",
    confirmReplace: "Your current sign-in on this site will be replaced.",
    confirmWarn: "Tap «Yes» only if you opened this link yourself from BeeApp in Telegram and this is your account. Purchases will go to it.",
    confirmYes: "Yes, this is my account",
    confirmNo: "No, this is not me",
    expiredTitle: "The payment link has expired",
    expiredText: "It works once and for 10 minutes. Go back to Telegram and tap “Pay in browser” again.",
  },
  report: {
    menuTitle: "Report a problem",
    menuDesc: "A bug, a mistake or something unclear — tell us",
    eyebrow: "Feedback",
    title: "What happened?",
    intro: "Describe what's wrong or unclear. The BeeApp team gets it together with your account and device details, so they don't have to ask.",
    categoryLabel: "Topic",
    cat_bug: "App bug",
    cat_unclear: "Unclear or incorrect",
    cat_payment: "Payment and access",
    cat_other: "Other",
    messageLabel: "Message",
    placeholder_bug: "What were you doing and what went wrong? E.g. tapped “Pick cartridge” and the screen froze.",
    placeholder_unclear: "Which lesson or screen, and what exactly is unclear or looks wrong?",
    placeholder_payment: "What did you pay for and when? What do you see instead of access?",
    placeholder_other: "Tell us what you'd like to report.",
    addScreenshot: "Attach a screenshot",
    removeScreenshot: "Remove screenshot",
    screenshot: "Screenshot",
    privacy: "Sent along with the text: your Telegram name or e-mail, subscription status, device model and language.",
    send: "Send",
    doneTitle: "Thanks — your message was sent",
    doneText: "The team will look at it soon. If they need details, they'll message you.",
    doneButton: "Done",
    tooMany: "Too many messages in a row. Try again in 10 minutes.",
    photoTooLarge: "The screenshot is too large — up to 8 MB.",
    failed: "Couldn't send. Check your connection and try again.",
    close: "Close",
    screenMenu: "Main menu",
  },
  linkPay: {
    eyebrow: "Card payment",
    viaBepaid: "by bank card",
    step1: "The payment page opened in a new window — pay there.",
    step2: "Come back here and tap “I've paid”.",
    step3: "We check the payment and open your access — usually within a few hours. You'll get a Telegram message.",
    claim: "I've paid",
    later: "I'll pay later",
    claimedTitle: "Thanks! We're checking the payment",
    claimedText: "As soon as it arrives we open your access — usually within a few hours. We'll send a Telegram message.",
    startFailed: "The payment page opened, but we couldn't record the order. If you pay, tell us via “Report a problem”.",
    claimFailed: "Couldn't send. Try again or tell us via “Report a problem”.",
  },
  payMethod: {
    forAccount: "Access opens for the account: {{name}}",
    eyebrow: "Payment",
    title: "How would you like to pay?",
    byRu: "Card",
    byRuHow: "For cards from Belarusian and Russian banks",
    byRuBrands: "Visa,Mastercard,MIR,Belkart",
    byRuPay: "Pay by card",
    byRuNote: "Access opens once the payment is checked — usually within a few hours.",
    byRuNoteAuto: "You are charged {{byn}} BYN (Belarusian roubles). Access opens as soon as you pay.",
    bynCredit: "Credit for unused days: −{{credit}} BYN, you pay {{due}} BYN",
    bynKept: "Renewal at your price: {{due}} BYN instead of {{list}} BYN",
    bepaidSandbox: "Test mode: no money is taken (test card 4200 0000 0000 0000).",
    bepaidError: "Could not open the payment page. Please try again.",
    returnPaidTitle: "Payment received",
    returnPaidText: "Your access is open — thank you!",
    returnPendingTitle: "Checking your payment",
    returnPendingText: "The payment is not confirmed yet. Access opens automatically once it does.",
    returnFailedTitle: "Payment did not go through",
    returnFailedText: "No money was taken. You can try again or choose another way to pay.",
    byRuNoLink: "For this plan we send a Belarus/Russia card payment link on request — usually within a few hours.",
    requestLink: "Request a payment link",
    requestScreen: "Plans — card payment BY/RU",
    requestText: "I'd like to pay for {{plan}} ({{term}}) with a Belarusian/Russian card — please send me a payment link.",
    world: "PayPal + Card",
    worldHow: "For cards from European and other banks — no PayPal account needed",
    worldBrands: "Visa,Mastercard,PayPal",
    worldPay: "Pay by card or PayPal",
    worldUnavailable: "PayPal is not available here.",
  },
};

export default en;
